module.exports = __webpack_public_path__ + "img/IMG_0300_L_WoodMatted_MockedUp.96c4681f.jpg";